<template>
  <div class="bidder-page">
    <!-- 提示信息 -->
    <div class="notice-section">
      <el-alert
        title="公告下方匿名下载文件的项目,可在此上传投标文件,非匿名项目在我的购标项目进入流程递交文件。"
        type="warning"
        :closable="false"
        show-icon>
      </el-alert>
    </div>

    <!-- 搜索区域 -->
    <div class="search-section">
        <el-form :model="searchForm" :inline="true" class="search-form">
          <el-form-item>
            <el-input v-model="searchForm.noticeName" placeholder="公告名称" clearable style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.sectionName" placeholder="标段名称" clearable style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="tenderNoticeName" label="公告名称" min-width="200">
          <template slot-scope="scope">
            <div>
              <el-link type="primary" :underline="false">{{ scope.row.tenderNoticeName }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="agencyName" label="招标代理机构" min-width="150"></el-table-column>
        <el-table-column prop="bidSectionCode" label="标段编号" min-width="150"></el-table-column>
        <el-table-column prop="bidSectionName" label="标段名称" min-width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.bidSectionName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="handleUploadBidDocument(scope.row)">上传投标文件</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getUploadDocumentList } from '@/api/modules/tenderNotice'
export default {
  name: 'UploadBid',
  data() {
    return {
      searchForm: {
        noticeName: '',
        sectionName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: []
    }
  },
  mounted() {
    this.getUploadDocumentList()
  },
  methods: {
    //上传投标文件
    handleUploadBidDocument(row) {
      this.$router.push({
        name: 'bidDocument',
        query: {
          sectionCode: row.bidSectionCode,
        }
      })
    },
    //  上传投标文件列表
    getUploadDocumentList() {
      getUploadDocumentList({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchForm
      }).then(res => {
        if (res.code == 200) {
          this.tableData =  res.data.records || []
          this.total = res.data.total || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error(res.msg || '获取列表失败')
        }
      }).catch(error => {
        console.error('获取上传投标文件列表失败:', error)
        this.tableData = []
        this.total = 0
        this.$message.error('获取列表失败')
      })
    },
    handleSearch() {
      this.currentPage = 1
      this.getUploadDocumentList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getUploadDocumentList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getUploadDocumentList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-page {
  .apply-minimal-gray-theme();
}

/* 提示信息区域 */
.notice-section {
  margin-bottom: 20px;
  
  /deep/ .el-alert {
    border-radius: 4px;
    border-left: 3px solid @warning-color;
  }
}
</style>
